import React, { Component } from 'react';
import { baseUrl } from '../../../../../../utils';

export default class VkTab extends Component {
    render() {
        const { tab } = this.props
        return (
            <>
                {tab != "My Profile Posts" ?
                    <div className="form-group">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">
                                    <i className={`fas fa-${tab  == "Hashtag" ? "hashtag" : "users"}`}></i>
                                </span>
                            </div>
                            <input className="autosearch mycheck form-control " id="feedsfield2" type="text" />
                        </div>
                        <span id="feedsfield2error" className="errorMessage required">This field is required.</span>
                    </div>
                    :
                    <div className="form-group text-center mt-7 mb-6">
                        <div className="py-3">
                            <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3" onclick="javascript:$('#create_feed').trigger('click');">
                                <span className="symbol symbol-25 me-3">
                                    <img src={baseUrl(`social-icons/vkontakte.svg`)} />
                                </span>
                                <span className="text-dark-50 font-weight-bolder font-size-base">Connect VKontakte</span>
                            </a>
                        </div>
                    </div>
                }
                <div className="hideforBSearch">
                    <div className="checkbox-inline">
                        <label htmlFor="feedscreatemoderation" className="form-check me-2">
                            <input type="checkbox" id="feedscreatemoderation" className="form-check-input me-2" value="1" />
                            Manually approve posts before making them public?
                        </label>
                    </div>
                </div>

            </>
        )
    }
}
